import { PROGRESS_STATE, STEP_TYPE } from '../utils/Constants';

const progressInitiated = PROGRESS_STATE.INITIATED;
const progressCompleted = PROGRESS_STATE.COMPLETED;
const progressNotStarted = PROGRESS_STATE.DEFAULT;

export const useStepper = ({ steps, currentLocation }) => {
  const lastLocation = steps.find((step) => step.type === STEP_TYPE.LAST)
    .paths[0];

  const setInitialState = () => {
    let obj = {};
    steps.forEach((step) => (obj[step.key] = progressNotStarted));
    return obj;
  };

  let progress = setInitialState();
  const getStepProgress = (currentLocation) => {
    const step = steps.find((step) =>
      step.paths.find((path) => path === currentLocation)
    );
    const pos = step.paths.indexOf(currentLocation) ?? -1;
    const stepName = step.key;
    const intermediatePathsQuantity = step.paths.length;

    return [stepName, pos, intermediatePathsQuantity];
  };

  const finishProgress = () => {
    let stepName = steps.find((step) => step.type === STEP_TYPE.LAST)?.key;
    progress[stepName] = progressCompleted;
  };

  const setPartialStepState = () => {
    const [stepName, pos, intermediatePathsQuantity] =
      getStepProgress(currentLocation);
    const fraction =
      pos === 0 ? progressInitiated : pos / intermediatePathsQuantity;
    progress[stepName] += fraction;
  };

  const setCascadeAutocomplete = () => {
    let clonedSteps = [...steps];
    let autocomplete = false;
    clonedSteps.reverse().forEach((step) => {
      const stepName = step.key;
      if (autocomplete) {
        progress[stepName] = progressCompleted;
      } else if (progress[stepName] >= progressInitiated) autocomplete = true;
    });
  };

  if (currentLocation !== lastLocation) {
    setPartialStepState();
  } else {
    finishProgress();
  }
  setCascadeAutocomplete();

  return progress;
};

export const usePaths = ({ steps, currentLocation }) => {
  let step = steps.find((step) =>
    step.paths.find((path) => path === currentLocation)
  );
  let stepIndex = step.paths.indexOf(currentLocation);
  let currentStepIndex = steps.findIndex((obj) => obj.key === step.key);

  const validateItsNotLast = (steps, currentLocation) => {
    let { paths } = steps[steps.length - 1];
    return (
      paths.includes(currentLocation) &&
      paths.indexOf(currentLocation) === paths.length
    );
  };

  const validateItsNotFirst = (steps, currentLocation) => {
    let { paths } = steps[0];
    return (
      paths.includes(currentLocation) && paths.indexOf(currentLocation) === 0
    );
  };

  let isLastPath = validateItsNotLast(steps, currentLocation);
  let isFirstPath = validateItsNotFirst(steps, currentLocation);

  const nextPath = () => {
    let next;

    if (!isLastPath && stepIndex + 1 === step.paths.length) {
      next = steps[currentStepIndex + 1].paths[0];
    } else {
      next = step.paths[stepIndex + 1];
    }
    return next;
  };

  const previousPath = () => {
    let previousPath;

    if (!isFirstPath && stepIndex === 0) {
      let previousStepPaths = steps[currentStepIndex - 1].paths;
      previousPath = previousStepPaths[previousStepPaths.length - 1];
    } else {
      previousPath = step.paths[stepIndex - 1];
    }
    return previousPath;
  };

  return { nextPath, previousPath };
};
